// extracted by mini-css-extract-plugin
export var container = "formum-container-module--container--55ac8";
export var info = "formum-container-module--info--1a7cb";
export var message = "formum-container-module--message--b2c3b";